import { pathOrders } from './orders/imports';
import { pathProducts } from './products/imports';
import { pathUsers } from './users/imports';
import { pathReservations } from './reservations/imports';
import { pathCashRegister } from './cash-register/imports';
import { pathTables } from './tables/imports';

export const ROOTS_DASHBOARD = '/dashboard';
export function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}
export function pathJoin(root: string, sublink: string[]) {
  return `${root}/${sublink.join('/')}`;
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  ...pathUsers(ROOTS_DASHBOARD),
  ...pathOrders(ROOTS_DASHBOARD),
  ...pathProducts(ROOTS_DASHBOARD),
  ...pathReservations(ROOTS_DASHBOARD),
  ...pathCashRegister(ROOTS_DASHBOARD),
  ...pathTables(ROOTS_DASHBOARD),
};
